/// <reference types="vite/client" />
/// <reference types="vite-plugin-svgr/client" />

import './styles/generated-colors.css'
import './styles/semantic-colors.css'
import './styles/spacing.css'
import './styles/text.css'
import './styles/radius.css'
import './styles/shadows.css'
import './styles/transitions.css'
import './styles/global.css'

import { createRoot } from 'react-dom/client'

import { initConfig } from './lib/config'
import { session, staff } from './store'

import { Application } from './Application'
import { initColorScheme } from './services/color-scheme'

// URLs from VITE_*; empty/unset falls back to shared localhost defaults.
// Do not put production API URLs in web-app/.env for local development.
initConfig({
  ...(import.meta.env['VITE_API_URL'] ? { apiUrl: import.meta.env['VITE_API_URL'] as string } : {}),
  ...(import.meta.env['VITE_STATIC_URL']
    ? { staticUrl: import.meta.env['VITE_STATIC_URL'] as string }
    : {}),
  googleClientId: (import.meta.env['VITE_GOOGLE_CLIENT_ID'] as string) || '',
  facebookAppId: (import.meta.env['VITE_FACEBOOK_APP_ID'] as string) || '',
})

initColorScheme()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

async function main() {
  // Resolve session before first paint so login never races restore.
  await Promise.all([session.restore(), staff.restore()])
  createRoot(rootEl!).render(<Application />)
}

void main()
